import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-securityBoxCode",
  "use": "icon-securityBoxCode-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-securityBoxCode\"><path d=\"M0 0h1024v1024H0z\" fill=\"#FFFFFF\" fill-opacity=\"0\" p-id=\"3356\" /><path d=\"M949.024 328.352v-0.224c0-0.704-0.096-1.408-0.16-2.112v-0.32a34.624 34.624 0 0 0-0.288-1.856v-0.32a33.504 33.504 0 0 0-1.792-6.304V317.12a33.152 33.152 0 0 0-1.92-3.968l-0.16-0.256a39.904 39.904 0 0 0-1.12-1.824l-0.128-0.192-125.312-187.68a67.52 67.52 0 0 0-56.32-30.08H257.024c-22.624-0.064-43.744 11.264-56.256 30.08L75.648 310.784l-0.16 0.224a33.44 33.44 0 0 0-3.2 6.08v0.064a29.664 29.664 0 0 0-2.144 8.448v0.32a34.208 34.208 0 0 0-0.192 2.144v508.96A67.712 67.712 0 0 0 137.6 904.672h743.808a67.712 67.712 0 0 0 67.616-67.648V328.352zM852.032 296h-308.8V160.736h218.624l90.176 135.264zM256.96 160.736h218.624V296h-308.8l90.176-135.264z m624.416 676.288H137.44V363.616h743.968v473.408z\" p-id=\"3357\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/securityBoxCode.svg
// module id = dm1Z
// module chunks = 69